/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebsitImageConfigInfoRespVo
 */
export interface WebsitImageConfigInfoRespVo {
    /**
     * 数据编号
     * @type {number}
     * @memberof WebsitImageConfigInfoRespVo
     */
    id?: number;
    /**
     * 图片类型：1-主页面轮播横幅，2-主页面轮播横幅右侧，3-主页面服务指南，4-通用顶部Logo，5-通用右侧快捷菜单，6-主页面中央横幅，7-主页面站点横幅，8-主页面顶部申请按钮，9-主页面TT汇率管理
     * @type {number}
     * @memberof WebsitImageConfigInfoRespVo
     */
    imageType?: number;
    /**
     * 标题（韩文）
     * @type {string}
     * @memberof WebsitImageConfigInfoRespVo
     */
    title?: string;
    /**
     * 标题（中文）
     * @type {string}
     * @memberof WebsitImageConfigInfoRespVo
     */
    titleCn?: string;
    /**
     * 内容（韩文）
     * @type {string}
     * @memberof WebsitImageConfigInfoRespVo
     */
    content?: string;
    /**
     * 内容（中文）
     * @type {string}
     * @memberof WebsitImageConfigInfoRespVo
     */
    contentCn?: string;
    /**
     * 韩文前景图片url
     * @type {string}
     * @memberof WebsitImageConfigInfoRespVo
     */
    frontImageKrUrl?: string;
    /**
     * 中文前景图片url
     * @type {string}
     * @memberof WebsitImageConfigInfoRespVo
     */
    frontImageCnUrl?: string;
    /**
     * 背景图片url
     * @type {string}
     * @memberof WebsitImageConfigInfoRespVo
     */
    backgroundImageUrl?: string;
    /**
     * 背景颜色
     * @type {string}
     * @memberof WebsitImageConfigInfoRespVo
     */
    backgrondColor?: string;
    /**
     * 跳转目标url
     * @type {string}
     * @memberof WebsitImageConfigInfoRespVo
     */
    targetUrl?: string;
    /**
     * 跳转的url是否要显示在新窗口内：0-不在新窗口，1-在新窗口
     * @type {number}
     * @memberof WebsitImageConfigInfoRespVo
     */
    targetWindow?: number;
    /**
     * 排序
     * @type {number}
     * @memberof WebsitImageConfigInfoRespVo
     */
    sort?: number;
    /**
     * 是否可用：0-不可用，1-可用
     * @type {number}
     * @memberof WebsitImageConfigInfoRespVo
     */
    enable?: number;
}

/**
 * Check if a given object implements the WebsitImageConfigInfoRespVo interface.
 */
export function instanceOfWebsitImageConfigInfoRespVo(value: object): value is WebsitImageConfigInfoRespVo {
    return true;
}

export function WebsitImageConfigInfoRespVoFromJSON(json: any): WebsitImageConfigInfoRespVo {
    return WebsitImageConfigInfoRespVoFromJSONTyped(json, false);
}

export function WebsitImageConfigInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebsitImageConfigInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'imageType': json['imageType'] == null ? undefined : json['imageType'],
        'title': json['title'] == null ? undefined : json['title'],
        'titleCn': json['titleCn'] == null ? undefined : json['titleCn'],
        'content': json['content'] == null ? undefined : json['content'],
        'contentCn': json['contentCn'] == null ? undefined : json['contentCn'],
        'frontImageKrUrl': json['frontImageKrUrl'] == null ? undefined : json['frontImageKrUrl'],
        'frontImageCnUrl': json['frontImageCnUrl'] == null ? undefined : json['frontImageCnUrl'],
        'backgroundImageUrl': json['backgroundImageUrl'] == null ? undefined : json['backgroundImageUrl'],
        'backgrondColor': json['backgrondColor'] == null ? undefined : json['backgrondColor'],
        'targetUrl': json['targetUrl'] == null ? undefined : json['targetUrl'],
        'targetWindow': json['targetWindow'] == null ? undefined : json['targetWindow'],
        'sort': json['sort'] == null ? undefined : json['sort'],
        'enable': json['enable'] == null ? undefined : json['enable'],
    };
}

export function WebsitImageConfigInfoRespVoToJSON(json: any): WebsitImageConfigInfoRespVo {
    return WebsitImageConfigInfoRespVoToJSONTyped(json, false);
}

export function WebsitImageConfigInfoRespVoToJSONTyped(value?: WebsitImageConfigInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'imageType': value['imageType'],
        'title': value['title'],
        'titleCn': value['titleCn'],
        'content': value['content'],
        'contentCn': value['contentCn'],
        'frontImageKrUrl': value['frontImageKrUrl'],
        'frontImageCnUrl': value['frontImageCnUrl'],
        'backgroundImageUrl': value['backgroundImageUrl'],
        'backgrondColor': value['backgrondColor'],
        'targetUrl': value['targetUrl'],
        'targetWindow': value['targetWindow'],
        'sort': value['sort'],
        'enable': value['enable'],
    };
}

